import { getToken, shouldAttachToken } from "./token";

const BASE_URL = "/appointment";

// 超过 16 位的 JSON 数字在 JS 中会丢失精度，解析前先转为字符串
const UNSAFE_JSON_INTEGER_PATTERN = /(:|,|\[)\s*(-?\d{16,})(?=\s*[,}\]])/g;

export function parseJsonWithSafeIntegers(text) {
  if (!text) return null;
  const sanitized = text.replace(
    UNSAFE_JSON_INTEGER_PATTERN,
    '$1"$2"'
  );
  return JSON.parse(sanitized);
}

function buildUrl(path) {
  if (!path.startsWith("/")) {
    path = `/${path}`;
  }
  return `${BASE_URL}${path}`;
}

function buildHeaders(path, customHeaders = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...customHeaders,
  };

  if (shouldAttachToken(path)) {
    const token = getToken();
    if (token) {
      headers.Authorization = token.startsWith("Bearer ")
        ? token
        : `Bearer ${token}`;
    }
  }

  return headers;
}

export async function request(path, options = {}) {
  const response = await fetch(buildUrl(path), {
    method: options.method || "GET",
    headers: buildHeaders(path, options.headers || {}),
    body: options.body ? JSON.stringify(options.body) : undefined,
  });

  let data = null;
  try {
    const text = await response.text();
    data = text ? parseJsonWithSafeIntegers(text) : null;
  } catch (e) {
    data = null;
  }

  if (!response.ok) {
    const message =
      (data && (data.message || data.msg)) ||
      `请求失败: ${response.status} ${response.statusText}`;
    const error = new Error(message);
    error.code = data && data.code;
    error.msg = data && data.msg;
    error.raw = data;
    throw error;
  }

  return data;
}
